var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18C4.67267 18 4 17.3273 4 16.5V7.5C4 6.67267 4.67267 6 5.5 6H18.5C19.3273 6 20 6.67267 20 7.5V16.5C20 17.3273 19.3273 18 18.5 18H5.5ZM5 16.5C5 16.776 5.224 17 5.5 17H18.5C18.776 17 19 16.776 19 16.5V10H5V16.5ZM19 9V7.5C19 7.224 18.776 7 18.5 7H5.5C5.224 7 5 7.224 5 7.5V9H19Z",
    fill: "#528AFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C7.224 13 7 12.776 7 12.5C7 12.224 7.224 12 7.5 12H13C13.276 12 13.5 12.224 13.5 12.5C13.5 12.776 13.276 13 13 13H7.5Z",
    fill: "#528AFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C7.224 15 7 14.776 7 14.5C7 14.224 7.224 14 7.5 14H11C11.276 14 11.5 14.224 11.5 14.5C11.5 14.776 11.276 15 11 15H7.5Z",
    fill: "#528AFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.a0d611f5.svg";
export { ForwardRef as ReactComponent };